import React from 'react';
import idxNameIconSVG from './Images/idxNameIcon.svg';
import idxCodeSVG from './Images/idxCode.svg';
import idxSerialSVG from './Images/idxSerial.svg';

export const idxCode = idxCodeSVG;
export const idxNameIcon = idxNameIconSVG;
export const idxSerial = idxSerialSVG;

export const windowsIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="74.611"
    height="74.841"
    viewBox="0 0 74.611 74.841"
  >
    <path
      id="path13"
      d="M0,10.6,30.491,6.444,30.5,35.854.028,36.028ZM30.477,39.243,30.5,68.68.024,64.49l0-25.444ZM34.173,5.9,74.6,0V35.481L34.173,35.8ZM74.611,39.52,74.6,74.841,34.173,69.135l-.057-29.681Z"
      fill="#793170"
    />
  </svg>
);

export const macIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60.626"
    height="71.975"
    viewBox="0 0 60.626 71.975"
  >
    <path
      id="path4"
      d="M59.355,56.091a39.131,39.131,0,0,1-3.87,6.957A35.348,35.348,0,0,1,50.5,69.072a9.67,9.67,0,0,1-6.406,2.821,16.057,16.057,0,0,1-5.918-1.413,16.98,16.98,0,0,0-6.371-1.408,17.556,17.556,0,0,0-6.551,1.408,17.627,17.627,0,0,1-5.661,1.488q-3.285.14-6.551-2.9a37.117,37.117,0,0,1-5.214-6.238A43.139,43.139,0,0,1,2.315,51.883,40.1,40.1,0,0,1,0,38.831a23.835,23.835,0,0,1,3.13-12.47,18.361,18.361,0,0,1,6.555-6.631,17.634,17.634,0,0,1,8.862-2.5,20.867,20.867,0,0,1,6.855,1.6,22.036,22.036,0,0,0,5.437,1.6,32.534,32.534,0,0,0,6.029-1.883,19.928,19.928,0,0,1,8.195-1.455q9.083.733,13.63,7.176-8.124,4.922-8.041,13.773a15.194,15.194,0,0,0,4.989,11.449,16.4,16.4,0,0,0,4.985,3.27q-.6,1.739-1.271,3.337ZM45.467,1.44a15.354,15.354,0,0,1-3.936,10.071c-3.163,3.7-6.989,5.835-11.138,5.5a11.206,11.206,0,0,1-.084-1.364A15.776,15.776,0,0,1,34.485,5.468a16.077,16.077,0,0,1,5.087-3.819A15.168,15.168,0,0,1,45.392,0a13.073,13.073,0,0,1,.076,1.44Z"
      transform="translate(0 -0.001)"
      fill="#793170"
    />
  </svg>
);

export const connectKeyIllustration = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="288.548"
    height="76.743"
    viewBox="0 0 288.548 76.743"
  >
    <g id="Group_1513" data-name="Group 1513" transform="translate(-484.547 -392.365)">
      <g id="Group_1512" data-name="Group 1512" transform="translate(484.547 392.365)">
        <g id="Group_1485" data-name="Group 1485" transform="translate(0 0)">
          <g id="Group_1483" data-name="Group 1483" transform="translate(0 25.889)">
            <path
              id="Subtraction_18"
              data-name="Subtraction 18"
              d="M21.249,0a1.369,1.369,0,0,0-.961.4c-.5.422-4.364,4.592-4.4,4.634l-.363,5.779-.088.094C13.1,13.408,1.419,25.9.864,26.44a1.9,1.9,0,0,0-.516.951,2.015,2.015,0,0,0-.053.5C.2,29.388.038,32.019,0,32.8a2.322,2.322,0,0,0,.366,1.394,2.841,2.841,0,0,0,1,.914c.26.146,2.806,1.42,6.031,3.034l.015.007.006,0h0c6.717,3.362,16.868,8.441,17.34,8.819a1.075,1.075,0,0,0,.687.24,2.524,2.524,0,0,0,1.414-.616c.478-.382,15.839-15.813,16.493-16.469l0,0a23.065,23.065,0,0,0,2.391,1.264,2.1,2.1,0,0,0,.805.181,1.528,1.528,0,0,0,1.182-.591c.133-.149.423-.454.758-.807h0c.7-.732,1.65-1.735,2.034-2.219l.165-.205.027-.033h0A5.145,5.145,0,0,0,52,25.5c.1-.712.043-4.81.013-7.011V18.48c-.006-.458-.011-.826-.013-1.057a2.579,2.579,0,0,0-.625-1.653A3.7,3.7,0,0,0,50.1,14.8c-.325-.15-3.9-2.052-8.434-4.459l0,0-.12-.064h0l-.02-.011C34,6.27,23.7.8,22.754.4A4.156,4.156,0,0,0,21.249,0Zm-4.5,30.794a1.581,1.581,0,0,1-.692-.168c-.386-.2-3.605-1.9-4.09-2.18A.586.586,0,0,1,11.654,28a.886.886,0,0,1,.316-.712c.174-.161.42-.433.7-.748.306-.339.653-.724.978-1.041a1.3,1.3,0,0,1,.943-.35,2.5,2.5,0,0,1,.993.226c.121.058.594.328,1.193.669h0c.922.526,2.07,1.181,2.5,1.382a.681.681,0,0,1,.446.479.652.652,0,0,1-.229.541c-.215.194-1.635,1.657-2.021,2.061A.971.971,0,0,1,16.751,30.794ZM2,28.7a.769.769,0,0,1-.3-.061,1.33,1.33,0,0,1-.385-1.781,1.908,1.908,0,0,1,.545-.742,1.146,1.146,0,0,1,.7-.278.769.769,0,0,1,.3.061,1.33,1.33,0,0,1,.385,1.781,1.909,1.909,0,0,1-.545.742A1.145,1.145,0,0,1,2,28.7ZM30.409,37.8a1.581,1.581,0,0,1-.692-.168c-.385-.2-3.6-1.9-4.09-2.18A.585.585,0,0,1,25.312,35a.887.887,0,0,1,.316-.712c.174-.161.42-.433.7-.748.306-.34.654-.724.979-1.041a1.3,1.3,0,0,1,.943-.35,2.505,2.505,0,0,1,.993.225c.121.058.594.327,1.192.669.923.527,2.072,1.182,2.5,1.383a.681.681,0,0,1,.446.479.652.652,0,0,1-.229.541c-.215.194-1.635,1.657-2.021,2.061A.971.971,0,0,1,30.409,37.8Z"
              transform="translate(52.054 47.209) rotate(180)"
              fill="#822973"
            />
            <path
              id="Path_1263"
              data-name="Path 1263"
              d="M-5868.78,10317.068s.358-10.232.3-11.12.344-2.891-1.743-3.882-33.694-17.283-34.158-17.434"
              transform="translate(5905.494 -10271.618)"
              fill="none"
              stroke="#f4f5fc"
              strokeWidth="4"
            />
          </g>
          <g id="Group_1484" data-name="Group 1484" transform="translate(168.29 0)">
            <path
              id="Subtraction_22"
              data-name="Subtraction 22"
              d="M70.125,76.743a7.936,7.936,0,0,1-1.218-.1,5.283,5.283,0,0,0-.554-.063c-.428-.016-14.264-3.007-25.983-5.564-12.295-2.682-25.459-5.583-25.639-5.677-.338-.176-.014-1.427,0-1.48h-.007c-.021,0-.064,0-.122,0a1,1,0,0,1-1.006-.621c-.119-.357-3.85-14.93-7.678-29.987C3.2,14.695.268,3,.069,1.972A1.792,1.792,0,0,1,.257.462,2.006,2.006,0,0,1,1.842,0C2,0,2.167,0,2.3.007h.04c.138,0,.28.006.417.006s.235,0,.339-.008h.061C5.023,0,35.286,2.11,49.83,3.122l.058,0,.036,0c4.764.332,7.693.535,8.2.567,1.847.115,1.964.713,2.141,1.618l0,.011c.038.192.076.391.136.6.338,1.211,12.025,44.083,12.138,44.5l47.173,6.2c.077.132.744,1.3.485,1.488-.142.1-11.881,4.649-22.676,8.8C86.581,71.122,74.4,75.776,73.005,76.224A9.415,9.415,0,0,1,70.125,76.743ZM21.251,64.307v1.519l2.917.75V64.921l-2.917-.615ZM3.539,4.546,15.517,52.211,69.25,42.75,59.507,7.156Z"
              transform="translate(0 0)"
              fill="#822973"
            />
            <path
              id="Path_1268"
              data-name="Path 1268"
              d="M-5472.846,10417.316l76.854-17.879"
              transform="translate(5486.361 -10353.279)"
              fill="#f4f5fc"
              stroke="#f4f5fc"
              strokeWidth="3"
            />
          </g>
        </g>
        <line
          id="Line_255"
          data-name="Line 255"
          x2="66.854"
          transform="translate(74.533 46.041)"
          fill="none"
          stroke="#793170"
          strokeWidth="1"
          strokeDasharray="6"
        />
        <path
          id="Polygon_1"
          data-name="Polygon 1"
          d="M7.227,0l7.227,11.745H0Z"
          transform="translate(150.873 38.813) rotate(90)"
          fill="#793170"
        />
      </g>
    </g>
  </svg>
);

export const beaconSerial = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="231.2"
    height="158.566"
    viewBox="0 0 231.2 158.566"
  >
    <defs>
      <filter
        id="Rectangle_1659"
        x="34.2"
        y="43.029"
        width="197"
        height="99"
        filterUnits="userSpaceOnUse"
      >
        <feOffset dy="3" input="SourceAlpha" />
        <feGaussianBlur stdDeviation="7.5" result="blur" />
        <feFlood floodColor="#793170" floodOpacity="0.2" />
        <feComposite operator="in" in2="blur" />
        <feComposite in="SourceGraphic" />
      </filter>
    </defs>
    <g id="Group_1502" data-name="Group 1502" transform="translate(-448.999 -267.549)">
      <path
        id="Subtraction_23"
        data-name="Subtraction 23"
        d="M8.77,158.566a6.517,6.517,0,0,1-2.081-.348,2.8,2.8,0,0,1-1.2-.695,5.273,5.273,0,0,0-.589-.542,14.726,14.726,0,0,1-3.595-4.19C-.206,150-.1,147.119.14,144.411c.243-2.76,4.448-72.187,4.783-77.824.166-2.8,1.056-8.458,1.771-13.005.557-3.539,1-6.333.967-6.905-.036-.71.577-12.537,1.17-23.975.511-9.863.994-19.177.994-20.107A2.287,2.287,0,0,1,10.84.585,3.874,3.874,0,0,1,12.85,0V0h.123a3.905,3.905,0,0,1,2.01.585A2.287,2.287,0,0,1,16,2.594c0,.93.483,10.244.994,20.105.593,11.44,1.206,23.267,1.17,23.977-.029.572.41,3.364.966,6.9.715,4.55,1.606,10.211,1.772,13.011.335,5.637,4.54,75.065,4.783,77.824.239,2.708.346,5.586-1.162,8.381a14.725,14.725,0,0,1-3.594,4.19,5.276,5.276,0,0,0-.589.542,2.8,2.8,0,0,1-1.2.695,6.518,6.518,0,0,1-2.081.348l-.141,0c-.467-.011-1.057-.017-1.753-.017-.957,0-1.847.011-2.185.015v0H12.85c-.37-.007-1.258-.017-2.185-.017-.7,0-1.286.006-1.753.017ZM8.509,126.35v29.633H17.1V126.35Z"
        transform="translate(448.999 267.549)"
        fill="#822973"
      />
      <path
        id="Path_1276"
        data-name="Path 1276"
        d="M-9367.607,8923.386c.834-2.4,30-58.391,32.82-63.627.006-.011-.415,2.591-.415,2.591l2.346,49.866Z"
        transform="translate(9842.428 -8528.235)"
        fill="none"
        stroke="#793170"
        strokeWidth="1"
      />
      <g id="Group_1501" data-name="Group 1501" transform="translate(505.99 330.028)">
        <g transform="matrix(1, 0, 0, 1, -56.99, -62.48)" filter="url(#Rectangle_1659)">
          <g
            id="Rectangle_1659-2"
            data-name="Rectangle 1659"
            transform="translate(56.7 62.53)"
            fill="#fff"
            stroke="#793170"
            strokeWidth="1"
          >
            <rect width="152" height="54" rx="5" stroke="none" />
            <rect x="0.5" y="0.5" width="151" height="53" rx="4.5" fill="none" />
          </g>
        </g>
        <g id="Group_1500" data-name="Group 1500" transform="translate(29.658 18.714)">
          <text
            id="_0_0_0_1_2_3"
            data-name="0 0 0 1 2 3"
            transform="translate(0.051 -2.665)"
            fill="#402b49"
            fontSize="18"
            fontFamily="SourceSansPro-Light, Source Sans Pro"
            fontWeight="300"
          >
            <tspan x="11.134" y="18">
              0 0 0 1 2 3
            </tspan>
          </text>
        </g>
      </g>
    </g>
  </svg>
);

export const beaconCode = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="163.215"
    height="158.529"
    viewBox="0 0 163.215 158.529"
  >
    <defs>
      <filter
        id="Rectangle_1659"
        x="34.479"
        y="42.5"
        width="128.736"
        height="99.427"
        filterUnits="userSpaceOnUse"
      >
        <feOffset dy="3" input="SourceAlpha" />
        <feGaussianBlur stdDeviation="7.5" result="blur" />
        <feFlood floodColor="#793170" floodOpacity="0.2" />
        <feComposite operator="in" in2="blur" />
        <feComposite in="SourceGraphic" />
      </filter>
    </defs>
    <g id="Group_1518" data-name="Group 1518" transform="translate(-528.534 -267.549)">
      <g id="Group_1502" data-name="Group 1502" transform="translate(528.534 267.549)">
        <path
          id="Subtraction_23"
          data-name="Subtraction 23"
          d="M17.049,158.529l-.139,0c-.473-.011-1.069-.017-1.772-.017-1.038,0-1.988.012-2.168.015,0,0,0,0-.021,0h-.1c-.193,0-1.151-.017-2.168-.017-.7,0-1.3.006-1.77.017l-.14,0a4.958,4.958,0,0,1-3.285-1.042,5.257,5.257,0,0,0-.591-.544A14.721,14.721,0,0,1,1.3,152.755C-.205,149.96-.1,147.083.14,144.376c.242-2.748,4.446-72.169,4.782-77.806.166-2.8,1.056-8.455,1.771-13,.556-3.538,1-6.332.967-6.9-.036-.709.577-12.535,1.169-23.971v-.007c.511-9.855.993-19.164.993-20.094C9.823.742,11.385.041,12.847,0l.062,0h.061c1.462.041,3.024.743,3.024,2.594,0,.929.482,10.238.993,20.094v.005c.593,11.438,1.205,23.263,1.169,23.972-.029.571.41,3.358.965,6.887.716,4.553,1.607,10.217,1.773,13.018.335,5.637,4.539,75.058,4.782,77.806.239,2.708.346,5.585-1.161,8.379a14.721,14.721,0,0,1-3.593,4.189,5.277,5.277,0,0,0-.59.543A4.958,4.958,0,0,1,17.049,158.529ZM7.156,121.36v9.549H18.446V121.36Zm0-12.523v9.549H18.446v-9.549Z"
          transform="translate(0 0)"
          fill="#822973"
        />
      </g>
      <path
        id="Path_1276"
        data-name="Path 1276"
        d="M-9367.607,8923.371c.833-2.4,29.993-58.377,32.813-63.612.006-.011-.415,2.59-.415,2.59l2.345,49.854Z"
        transform="translate(9921.957 -8528.25)"
        fill="none"
        stroke="#793170"
        strokeWidth="1"
      />
      <g id="Group_1501" data-name="Group 1501" transform="translate(585.513 330.013)">
        <g transform="matrix(1, 0, 0, 1, -56.98, -62.46)" filter="url(#Rectangle_1659)">
          <g
            id="Rectangle_1659-2"
            data-name="Rectangle 1659"
            transform="translate(56.98 62)"
            fill="#fff"
            stroke="#793170"
            strokeWidth="1"
          >
            <rect width="83.736" height="54.427" rx="5" stroke="none" />
            <rect x="0.5" y="0.5" width="82.736" height="53.427" rx="4.5" fill="none" />
          </g>
        </g>
        <g id="Group_1500" data-name="Group 1500" transform="translate(8.049 13.536)">
          <text
            id="a1b2"
            fill="#402b49"
            fontSize="18"
            fontFamily="SourceSansPro-Light, Source Sans Pro"
            fontWeight="300"
          >
            <tspan x="14.183" y="18">
              a1b2
            </tspan>
          </text>
        </g>
      </g>
    </g>
  </svg>
);

export const deviceNameIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="238.215"
    height="158.529"
    viewBox="0 0 238.215 158.529"
  >
    <defs>
      <filter
        id="Rectangle_1659"
        x="34.479"
        y="42.5"
        width="203.736"
        height="99.427"
        filterUnits="userSpaceOnUse"
      >
        <feOffset dy="3" input="SourceAlpha" />
        <feGaussianBlur stdDeviation="7.5" result="blur" />
        <feFlood floodColor="#793170" floodOpacity="0.2" />
        <feComposite operator="in" in2="blur" />
        <feComposite in="SourceGraphic" />
      </filter>
    </defs>
    <g id="Group_1518" data-name="Group 1518" transform="translate(-528.534 -267.549)">
      <g id="Group_1502" data-name="Group 1502" transform="translate(528.534 267.549)">
        <path
          id="Subtraction_23"
          data-name="Subtraction 23"
          d="M17.049,158.529l-.139,0c-.473-.011-1.069-.017-1.772-.017-1.038,0-1.988.012-2.168.015,0,0,0,0-.021,0h-.1c-.193,0-1.151-.017-2.168-.017-.7,0-1.3.006-1.77.017l-.14,0a4.958,4.958,0,0,1-3.285-1.042,5.257,5.257,0,0,0-.591-.544A14.721,14.721,0,0,1,1.3,152.755C-.205,149.96-.1,147.083.14,144.376c.242-2.748,4.446-72.169,4.782-77.806.166-2.8,1.056-8.455,1.771-13,.556-3.538,1-6.332.967-6.9-.036-.709.577-12.535,1.169-23.971v-.007c.511-9.855.993-19.164.993-20.094C9.823.742,11.385.041,12.847,0l.062,0h.061c1.462.041,3.024.743,3.024,2.594,0,.929.482,10.238.993,20.094v.005c.593,11.438,1.205,23.263,1.169,23.972-.029.571.41,3.358.965,6.887.716,4.553,1.607,10.217,1.773,13.018.335,5.637,4.539,75.058,4.782,77.806.239,2.708.346,5.585-1.161,8.379a14.721,14.721,0,0,1-3.593,4.189,5.277,5.277,0,0,0-.59.543A4.958,4.958,0,0,1,17.049,158.529ZM7.156,121.36v9.549H18.446V121.36Zm0-12.523v9.549H18.446v-9.549Z"
          transform="translate(0 0)"
          fill="#822973"
        />
      </g>
      <path
        id="Path_1276"
        data-name="Path 1276"
        d="M-9367.859,8884.681l33.064-24.922-.415,2.59,1.167,48.5Z"
        transform="translate(9921.957 -8528.25)"
        fill="none"
        stroke="#793170"
        strokeWidth="1"
      />
      <g id="Group_1501" data-name="Group 1501" transform="translate(585.513 330.013)">
        <g transform="matrix(1, 0, 0, 1, -56.98, -62.46)" filter="url(#Rectangle_1659)">
          <g
            id="Rectangle_1659-2"
            data-name="Rectangle 1659"
            transform="translate(56.98 62)"
            fill="#fff"
            stroke="#793170"
            strokeWidth="1"
          >
            <rect width="158.736" height="54.427" rx="5" stroke="none" />
            <rect x="0.5" y="0.5" width="157.736" height="53.427" rx="4.5" fill="none" />
          </g>
        </g>
        <g id="Group_1500" data-name="Group 1500" transform="translate(5.02 13.536)">
          <text
            id="Paul_s_beacon"
            data-name="Paul’s beacon"
            fill="#402b49"
            fontSize="18"
            fontFamily="SourceSansPro-Light, Source Sans Pro"
            fontWeight="300"
          >
            <tspan x="27.133" y="18">
              Paul’s Beacon
            </tspan>
          </text>
        </g>
      </g>
    </g>
  </svg>
);
export const connectionSymbol = (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="15.297" viewBox="0 0 28 15.297">
    <g id="Group_1523" data-name="Group 1523" transform="translate(-574.657 -614.583)">
      <circle
        id="Ellipse_64"
        data-name="Ellipse 64"
        cx="3"
        cy="3"
        r="3"
        transform="translate(586 619)"
        fill="#822973"
      />
      <g id="Group_1505" data-name="Group 1505" transform="translate(593.157 625.681) rotate(-90)">
        <path
          id="Path_1272"
          data-name="Path 1272"
          d="M7.681,0a4.816,4.816,0,0,1-4.02,2.148A4.842,4.842,0,0,1,0,.472"
          transform="translate(0 0)"
          fill="none"
          stroke="#822973"
          strokeWidth="1"
        />
      </g>
      <g id="Group_1506" data-name="Group 1506" transform="translate(595.505 627.203) rotate(-90)">
        <path
          id="Path_1272-2"
          data-name="Path 1272"
          d="M11.2,0A7.025,7.025,0,0,1,5.34,3.133,7.063,7.063,0,0,1,0,.688"
          transform="translate(0 0)"
          fill="none"
          stroke="#822973"
          strokeWidth="1"
        />
      </g>
      <g id="Group_1507" data-name="Group 1507" transform="translate(598.111 629.463) rotate(-90)">
        <path
          id="Path_1272-3"
          data-name="Path 1272"
          d="M14.463,0a9.069,9.069,0,0,1-7.57,4.045A9.117,9.117,0,0,1,0,.888"
          transform="translate(0 0)"
          fill="none"
          stroke="#822973"
          strokeWidth="1"
        />
      </g>
      <g id="Group_1508" data-name="Group 1508" transform="translate(584.156 618) rotate(90)">
        <path
          id="Path_1272-4"
          data-name="Path 1272"
          d="M7.681,0a4.816,4.816,0,0,1-4.02,2.148A4.842,4.842,0,0,1,0,.472"
          transform="translate(0 0)"
          fill="none"
          stroke="#822973"
          strokeWidth="1"
        />
      </g>
      <g id="Group_1509" data-name="Group 1509" transform="translate(581.808 616) rotate(90)">
        <path
          id="Path_1272-5"
          data-name="Path 1272"
          d="M11.2,0A7.025,7.025,0,0,1,5.34,3.133,7.063,7.063,0,0,1,0,.688"
          transform="translate(0 0)"
          fill="none"
          stroke="#822973"
          strokeWidth="1"
        />
      </g>
      <g id="Group_1510" data-name="Group 1510" transform="translate(579.202 615) rotate(90)">
        <path
          id="Path_1272-6"
          data-name="Path 1272"
          d="M14.463,0a9.069,9.069,0,0,1-7.57,4.045A9.117,9.117,0,0,1,0,.888"
          transform="translate(0 0)"
          fill="none"
          stroke="#822973"
          strokeWidth="1"
        />
      </g>
    </g>
  </svg>
);
